import { getLanguageCode, getCurrencyCode } from '../utils/i18nCustom'
import axios from 'axios';
import tests from './tests';
import users from './users';
import categories from './categories';
import attributes from './attributes';
import notify from './notify';
import reviews from './reviews';

const axiosInstance = axios.create({
  baseURL: window.location.origin,
  headers: {
    common: {
      'Accept-Language': getLanguageCode(),
      'Accept-Currency': getCurrencyCode(),
    }
  }
});

const api = {
  tests: tests(axiosInstance),
  users: users(axiosInstance),
  categories: categories(axiosInstance),
  attributes: attributes(axiosInstance),
  notify: notify(axiosInstance),
  reviews: reviews(axiosInstance),
};

export default api;
